import { StorageInterface } from "./storage.interface";

import { observable, action } from "mobx";

export class Preference<T = string | undefined> {
  constructor(
    private key: string,
    private service: StorageInterface,
    private _initialValue?: T
  ) {
    this.ready$ = this._initialize();

    this.ready$.then(() => this.setReady(true));
  }

  public ready$: Promise<T>;

  @observable
  public ready = false;

  @action
  private setReady(value: boolean) {
    this.ready = value;
  }

  private async _initialize() {
    const value = await this.service.getItem(this.key);
    if (value) {
      const parsed = JSON.parse(value);
      this.setValue(parsed, true);
      return parsed;
    } else return this._initialValue;
  }

  @observable public value = this._initialValue;

  public flatValue = this._initialValue;

  @action
  public setValue = (value: T, skipPersistence = false) => {
    this.value = value;
    this.flatValue = value;
    if (!skipPersistence) this.service.setItem(this.key, JSON.stringify(value));
  };

  @action
  public clearValue = () => {
    this.value = this._initialValue;
    this.flatValue = this._initialValue;

    this.service.removeItem(this.key);
  };
}
